<div class="gerar-pdf-status">
  <p *ngIf="state === 'loading'">Carregando proposta...</p>
  <p *ngIf="state === 'generating'">Gerando PDF...</p>
  <p *ngIf="state === 'success'" class="success">PDF gerado com sucesso.</p>
  <p *ngIf="state === 'error'" class="error">Erro: {{ errorMessage }}</p>
</div>

<!-- Off-screen render area required by html2pdf.js -->
<div class="pdf-render-area">
  <hr-ol-pdf-acceptance #olPdfAcceptance></hr-ol-pdf-acceptance>
</div>
